<template>
  <div class="d-flex flex-column border">
    <div class="d-flex p-2 border-bottom justify-content-around align-items-center">
      <div>
        <select class="form-control">
          <option>全部出貨方式</option>
        </select>
      </div>
      <div><button type="button"
          class="btn btn-outline-secondary"
          :class="{active:date_now_btn===0}" @click="date_now_btn = 0">
          {{new Date() | moment("MM/DD")+"今日（3）"}}
          </button></div>
      <div><button type="button"
          class="btn btn-outline-secondary"
          :class="{active:date_now_btn===1}" @click="date_now_btn = 1">
          {{new Date() | moment('add', '1 days', "MM/DD")+"明日（7）"}}
          </button>
      </div>
      <div>
        <button type="button"
          class="btn btn-outline-secondary"
          :class="{active:date_now_btn===2}" @click="date_now_btn = 2">
          {{new Date() | moment('add', '2 days', "MM/DD")+"後日（0）"}}
          </button>
      </div>
      <div>
        <a href="#" @click.prevent="">過期單（1）</a>
      </div>
      <div>
        <a href="#" @click.prevent="">所有清單</a>
      </div>
    </div>
    <div class="d-flex flex-column p-2">
      <div class="d-flex align-items-center">
        <small>總共3筆</small>
        <div class="ml-5">
          <button type="button" class="btn btn-outline-secondary">全選</button>
        </div>
        <div class="ml-5">
          <button type="button" class="btn btn-primary">預覽出貨表</button>
        </div>
        <small class="ml-5">
          <u>※建議只選擇一種出貨方式列印清單</u>
        </small>
      </div>
      <table class="table table-bordered text-left">
        <thead>
          <tr>
            <th>
              <b-form-checkbox>No</b-form-checkbox>
            </th>
            <th>出貨日</th>
            <th>品項</th>
            <th>數量</th>
            <th>收件人</th>
            <th>地址</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="7">
              <b-form-checkbox>郵局宅配2筆</b-form-checkbox>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="7">
              <b-form-checkbox>貨到付款1筆</b-form-checkbox>
            </td>
          </tr>
          <tr>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex flex-column bg-info p-2 text-left">
        <span>今日可出貨數量：</span>
        <div class="d-flex">
          <div class="d-flex flex-column">
            <div class="d-flex">
              <span>有聲書（九版）</span>
              <span class="ml-4">4件</span>
            </div>
            <div class="d-flex">
              <span>英語篇（九版）</span>
              <span class="ml-4">1件</span>
            </div>
            <div class="d-flex">
              <span>日語篇（九版）</span>
              <span class="ml-4">1件</span>
            </div>
          </div>
          <div class="d-flex flex-column ml-5">
            <div class="d-flex">
              <span>總庫存量</span>
              <span class="ml-4">20件（尚可）</span>
            </div>
            <div class="d-flex">
              <span>總庫存量</span>
              <span class="ml-4">0件（無法出貨）</span>
            </div>
            <div class="d-flex">
              <span>總庫存量</span>
              <span class="ml-4">10件（尚可）</span>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex align-items-center pt-3">
        <small>總共3筆</small>
        <div class="ml-5">
          <button type="button" class="btn btn-outline-secondary">全選</button>
        </div>
        <div class="ml-5">
          <button type="button" class="btn btn-primary" v-b-modal.viewShipList>預覽出貨表</button>
        </div>
      </div>
    </div>
    <b-modal id="viewShipList" title="預覽出貨表" size="xl" ok-title="列印出貨單" cancel-title="取消">
      <div class="d-flex flex-column">
        <span>請再次確認出貨件數</span>
        <div class="d-flex flex-column p-2 text-left" style="background-color: rgb(243, 174, 109);">
        <span>本次出貨數量：</span>
        <div class="d-flex">
          <div class="d-flex flex-column">
            <div class="d-flex">
              <span>有聲書（九版）</span>
              <span class="ml-4">4件</span>
            </div>
            <div class="d-flex">
              <span>日語篇（九版）</span>
              <span class="ml-4">1件</span>
            </div>
          </div>
          <div class="d-flex flex-column ml-5">
            <div class="d-flex">
              <span>總庫存量</span>
              <span class="ml-4">20件（尚可）</span>
            </div>
            <div class="d-flex">
              <span>總庫存量</span>
              <span class="ml-4">10件（尚可）</span>
            </div>
          </div>
        </div>
      </div>
       <table class="table table-bordered">
          <thead>
            <tr>
              <th>No</th>
              <th colspan="2">出貨狀態</th>
              <th>出貨商品</th>
              <th>數量</th>
              <th>收件人</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colspan="3">郵局寄送 訂單合計 2筆</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tr>
              <td colspan="3">貨到付款 訂單合計 0筆</td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <small>請確定本次出貨數量與總庫存量</small>
          <small>／</small>
          <small>有貨品目前缺貨中</small>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      date_now_btn: 0,
    };
  },
  created() {

  },
};

</script>

<style lang="scss">
.aaa{
  background-color: rgb(243, 174, 109);
}
</style>
